export function addHorizontalClass(horizontalFilterPanel: boolean ): string{
    return horizontalFilterPanel ? '-horizontal' : '';
}